(function () {
  function pad(n) {
    return String(Math.max(n, 0)).padStart(2, '0');
  }

  function tick(el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) return;

    var days = el.querySelector('[data-lc-days]');
    var hours = el.querySelector('[data-lc-hours]');
    var minutes = el.querySelector('[data-lc-minutes]');
    var seconds = el.querySelector('[data-lc-seconds]');

    function update() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (days) days.textContent = '00';
        if (hours) hours.textContent = '00';
        if (minutes) minutes.textContent = '00';
        if (seconds) seconds.textContent = '00';
        return false;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
      return true;
    }

    if (update()) {
      var timer = window.setInterval(function () {
        if (!update()) window.clearInterval(timer);
      }, 1000);
    }
  }

  document.querySelectorAll('[data-lc-countdown]').forEach(tick);
})();
